import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';

import apiClient from '../apiClient/apiClient';
import { CouponGroupKeys } from '../couponGroup/couponGroup.types';
import { MenuKeys } from '../menu/menu.types';
import { ExtractsRequestBody, ExtractsResponse, PublishMenusRequestBody } from './extract.types';

export const getExtracts = async (body: ExtractsRequestBody) => {
  try {
    // does not use react-query because it was not compatible with ag-grid infinite data model
    const response = await apiClient.post<ExtractsResponse>('/extracts', body);
    return response;
  } catch (error) {
    throw new Error((error as AxiosError).message);
  }
};

export const useExtractDsc = () => {
  return useMutation((params) => {
    return apiClient.post(`/extracts/dsc`);
  });
};

export const useExtractMenu = () => {
  return useMutation((menusToExtract: MenuKeys[]) => {
    return apiClient.post(`/extracts/menus`, menusToExtract);
  });
};

export const useActivateMenu = () => {
  return useMutation((menusToActivate: MenuKeys[]) => {
    return apiClient.post(`/extracts/activate-menus`, menusToActivate);
  });
};

export const useExtractCouponGroup = () => {
  return useMutation((couponGroupToExtract: CouponGroupKeys) => {
    return apiClient.post(`extracts/coupon-groups`, couponGroupToExtract);
  });
};

export const useExtractMasterFile = () => {
  return useMutation((params) => {
    return apiClient.post(`/extracts/master-file`);
  });
};

export const useExtractWebStoreXref = () => {
  return useMutation((params) => {
    return apiClient.post(`/extracts/web-store-xref`);
  });
};

export const usePublishMenu = () => {
  return useMutation(async (menusToPublish: PublishMenusRequestBody) => {
    const response = await apiClient.post(`/publish/menus`, menusToPublish);
    return response.data;
  });
};

export const useMenuChannels = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<string[]>>(
    ['menuChannels'],
    () => apiClient.get(`/publish/menu-channels`),
    { enabled }
  );
}

export const useExtractManInvGroup = () => {
  return useMutation((id: number) => {
    return apiClient.post(`/extracts/maninv/group/${id}`);
  });
};

export const useDeleteExtractErrors = () => {
  return useMutation((params)  => {
    return apiClient.post(`/extracts/deleteUserExtractErrors`);
  });
};
